import { Link } from "react-router-dom";
import { ProductsEnum } from "@ferry/journey-services";

interface Props {
    policyNumber: string;
}

export const SetUpDirectDebitBanner = ({ policyNumber }: Props) => (
    <div className="inner-container">
        <div className="banner error-banner">
            <div className="banner-icon" />
            <div className="banner-text">
                <p>
                    We need to set up a Direct Debit so we can refund your bank account (we won’t use it to take any payments). When your refund arrives, you
                    can cancel the Direct Debit with your bank.
                </p>
                <Link
                    id="payNow"
                    className="btn btn-white-dashboard"
                    state={{
                        verifyCardFailed: false,
                        product: ProductsEnum.WOLF_MOTOR,
                    }}
                    to={{ pathname: `/dashboard/${policyNumber}/paymentDetails/addDirectDebit` }}>
                    Update now
                </Link>
            </div>
        </div>
    </div>
);
